module.exports = __webpack_public_path__ + "img/FF_Asset_Info_Web_1.a80e57fe.png";